var map = {
	"./AcidosYBases.mp4": "04c5",
	"./Amibiasis.mp4": "3aa3",
	"./Ascariasis.mp4": "8136",
	"./BrazoHidraulico.mp4": "c815",
	"./CalorYFrio.mp4": "a1a5",
	"./Calorimetria1.mp4": "5865",
	"./Calorimetria2.mp4": "6827",
	"./Cargas.mp4": "d80f",
	"./Ciclones.mp4": "f9ee",
	"./Covid-19.mp4": "6b30",
	"./Covid-EAS.mp4": "7f77",
	"./DesayunoMetalico.mp4": "dc12",
	"./Desengrasante.mp4": "1097",
	"./DetectorDePHMagico.mp4": "583b",
	"./DetergenteMultiusos.mp4": "8cc4",
	"./EnergiaEolica.mp4": "0f70",
	"./EnergiaTermoelectrica.mp4": "3209",
	"./Fotoceldas.mp4": "5179",
	"./FotonesYElectrones.mp4": "b7dc",
	"./GelAntibacterial.mp4": "dc7c",
	"./GloboCaprichoso.mp4": "1363",
	"./HuevoRadioactivo.mp4": "ec54",
	"./JabonLiquidoParaManos.mp4": "0171",
	"./LamparaDeLava.mp4": "6cae",
	"./Limpiavidrios.mp4": "5725",
	"./MambaNegra.mp4": "5ffe",
	"./Momento.mp4": "6a07",
	"./MotorStirling.mp4": "3687",
	"./MovimientoPerpetuo.mp4": "9811",
	"./NieveArtificial.mp4": "662b",
	"./Ondas.mp4": "6f7d",
	"./Pendulos.mp4": "27e1",
	"./PinoLechoso.mp4": "3e7b",
	"./PlantasHidroelectricas.mp4": "8684",
	"./SalesCuaternariasDeAmonio.mp4": "35b1",
	"./SecretosOrina.mp4": "b80f",
	"./Slime.mp4": "27f1",
	"./TintaInvisible.mp4": "91b5",
	"./Venturi.mp4": "92b2",
	"./YogurthYMermeladaNatural.mp4": "041a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a67c";